window.updateItemsCount = (count) => {
  document.querySelectorAll('cart-items-quantity').forEach((el) => {
    el.updateCount && el.updateCount(count);
  });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    const btn = this.querySelector('button');
    if (btn) {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems && cartItems.submitQuantity(this.dataset.index, 0);
      });
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }
}

class CartItems extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  cartSectionUrl = `${routes.cart_url}?section_id=main-cart-items`;

  constructor() {
    super();
    this.inputsQty = null;
  }

  init() {
    console.log('init -> ', this.tagName.toLowerCase());
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    // Set listeners on qty changes
    this.inputsQty = this.querySelectorAll('alp-product-quantity-selector');
    if (this.inputsQty.length) {
      this.inputsQty.forEach((inputEl) => {
        inputEl.addEventListener(PUB_SUB_EVENTS.quantityChanged, this.onProductQtyChanged.bind(this));
      })
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.inputsQty.length) {
      this.inputsQty.forEach((inputEl) => {
        inputEl.removeEventListener(PUB_SUB_EVENTS.quantityChanged, this.onProductQtyChanged.bind(this));
      })
    }
  }

  onProductQtyChanged(eventParams) {
    const { detail } = eventParams;
    console.log('onProductQtyChanged > : ', eventParams);
    this.submitQuantity(detail.dataset.index, detail.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(this.cartSectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items') || html.querySelector('cart-drawer-items');

        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        section: this.dataset.id,
        selector: 'cart-items.cart-main-container'
      }
    ];
  }

  restoreLineQuantity(line) {
    const lineEl = this.querySelector(`div[data-index="${line}"].cart-product-line`);
    if (lineEl) {
      const qtySelectorEl = lineEl.querySelector('alp-product-quantity-selector');
      const value = lineEl.dataset.quantity;
      value && qtySelectorEl.setValue(value);
    }
  }

  toggleEmptyStatus(count) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');

    cartDrawerWrapper && cartDrawerWrapper.classList.toggle('is-empty', count === 0);
  }

  updateCartContent(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.querySelector(section.selector);
      const shopifySectionHtmlString = parsedState.sections[section.section];

      if (sectionElement && shopifySectionHtmlString) {
        sectionElement.replaceWith(AlpHelpers.getSectionDOM(shopifySectionHtmlString, section.selector));
      }
    });
  }

  submitQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...AlpHelpers.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.restoreLineQuantity(line);
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.toggleEmptyStatus(parsedState.item_count);

        // Update cart items count
        window.updateItemsCount (parsedState.item_count);

        // Update content
        this.updateCartContent(parsedState);
      })
      .catch((error) => {
        console.log('error --> ', error);
        this.updateLiveRegions(line, window.cartStrings.error);
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineEl = this.querySelector(`div[data-index="${line}"].cart-product-line`);
    if (lineEl) {
      const wrapperEl = this.querySelector('.error-message-wrapper');
      const messageContainer = wrapperEl.querySelector('.error-message');

      if (message) {
        if (messageContainer) {
          messageContainer.innerText = message;
        }
        wrapperEl.classList.remove('hidden');

        setTimeout(() => {
          wrapperEl.classList.add('hidden');
        }, 5000);
      }
    }
  }

  getCartLineOverlayElement(line) {
    const lineEl = this.querySelector(`div[data-index="${line}"].cart-product-line`);

    if (lineEl) {
      return lineEl.querySelector('.overlay-spinner-loading')
    }

    return null;
  }

  enableLoading(line) {
    const layer = this.getCartLineOverlayElement(line);
    layer && layer.classList.remove('hidden');
  }

  disableLoading(line) {
    const layer = this.getCartLineOverlayElement(line);
    layer && layer.classList.add('hidden');
  }
}

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      AlpHelpers.debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...AlpHelpers.fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER)
    );
  }
}


class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.querySelector(section.selector);
      const shopifySection = parsedState.sections[section.section];

      if (sectionElement && shopifySection) {
        sectionElement.innerHTML = AlpHelpers.getSectionInnerHTML(shopifySection, section.selector);
      }
    });

    // Search items count
    const count = this.getItemCountFormSectionHtml(parsedState.sections['cart-drawer']);

    this.updateItemsCount(count);

    setTimeout(() => {
      const cartDrawerItemsEl = this.querySelector('cart-drawer-items');
      cartDrawerItemsEl && cartDrawerItemsEl.toggleEmptyStatus(count);

      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getItemCountFormSectionHtml(sectionStr) {
    if (sectionStr) {
      const tag = AlpHelpers.getSectionDOM(sectionStr, 'cart-drawer');
      if (tag && tag.dataset.itemsCount) {
        return parseInt(tag.dataset.itemsCount, 10);
      }
    }

    return null;
  }

  updateItemsCount(count) {
    count && window.updateItemsCount(count);
  }

  getSectionsToRender() {
    return [
      {
        section: 'cart-drawer',
        selector: 'cart-drawer',
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}


class CartDrawerItems extends CartItems {
  cartSectionUrl = `${routes.cart_url}?section_id=cart-drawer`;
  getSectionsToRender() {
    return [
      {
        section: 'cart-drawer',
        selector: 'cart-drawer .drawer__inner'
      }
    ];
  }
}

class CartItemsQuantity extends HTMLElement {
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();
    this.cartItemsQtyEl = null;
  }

  init() {
    this.cartItemsQtyEl = this.querySelector('.cart-nb-items');
  }

  updateCount(itemsCount) {
    if (!this.cartItemsQtyEl) {
      return;
    }
    this.cartItemsQtyEl.innerText = itemsCount;
    // Hide if 0
    this.cartItemsQtyEl.classList.toggle('hidden', itemsCount === 0);
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
}


class CartFooter extends HTMLElement {
  constructor() {
    super();
  }
}



customElements.define('cart-remove-button', CartRemoveButton);
customElements.define('cart-items', CartItems);
customElements.define('cart-footer', CartFooter);
customElements.define('cart-note', CartNote);
customElements.define('cart-drawer', CartDrawer);
customElements.define('cart-drawer-items', CartDrawerItems);
customElements.define('cart-items-quantity', CartItemsQuantity);
